import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, CardHeader } from "@mui/material";
import { LeagueTable as LeagueTableBase } from "../common/LeagueTable";
export const LeagueTable = ({ matches }) => {
    return (_jsx(Card, { elevation: 3, sx: { mb: 4 }, children: _jsxs(CardContent, { children: [_jsx(CardHeader, { title: "League Table" }), _jsx(LeagueTableBase, { matches: matches })] }) }));
};
